import * as moment from "moment";
import { exportToCSV } from "@common/utils/exportToCSV";
import { Constants } from "@constants/shared";


console.log("FeesController file loaded");

class FeesController implements angular.IOnInit {
  public isLoadingIndividualClientsAuditExcel: boolean = false;

  public currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
  public selectedCurrency;

  // filters
  public currentDate;
  public lastMonth;

  // Top/Bottom Portfolio Fees - moved to portfolio-fees component
  public portfolioFeeDate;
  public portfolioFeesRef: any = {};

  //card hide and shows
  public showPortfolioFee: boolean = true;
  public isPortfolioFeeCollapsed: boolean = false; // Tracks collapsed state for reusable-card binding
  public showClientFee: boolean = true;
  public isClientFeeCollapsed: boolean = false; // Tracks collapsed state for reusable-card binding
  public showFeeTypesFee: boolean = true;
  public isFeeTypesFeeCollapsed: boolean = false; // Tracks collapsed state for reusable-card binding

  // Top Bottom Client - moved to client-fees component
  public clientFeeDate;
  public clientFeesRef: any = {};

  // Top Bottom Fee Types (logic moved to fee-type-fees component)
  public topFeeTypesFees; // Kept for export functionality
  public feeTypesFeeDate;
  public feeTypeFeesRef: any = {};

  // FeeCalculationType List
  public feeCalulationTypes = [
    {
      name: "Combined",
      value: FeeCalculationType.COMBINED,
    },
    {
      name: "MCB",
      value: FeeCalculationType.MCB,
    },
    {
      name: "EDR",
      value: FeeCalculationType.EDR,
    },
  ];

  public isLocalOrUATEnvironment: boolean = false;

  /** @ngInject */
  constructor(
    private $scope: angular.IScope,
  ) {
    this.currentDate = new Date();

    this.portfolioFeeDate = moment(this.currentDate)
      .subtract(1, "months")
      .endOf("month")
      .format("YYYY-MM-DD");

    this.lastMonth = new Date(
      moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
    this.clientFeeDate = new Date(
      moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
    this.feeTypesFeeDate = new Date(
      moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
  }

  $onInit() {
    // Check if we're in local or UAT environment (moved to $onInit to ensure location is available)
    try {
      const environment = Constants.getEnvironment();
      this.isLocalOrUATEnvironment = environment === "Local" || environment === Constants.STAGE || environment === Constants.DEV;
    } catch (error) {
      console.error("Error detecting environment:", error);
      this.isLocalOrUATEnvironment = false;
    }

    this.selectedCurrency = "MUR";

    // Sync showPortfolioFee with isPortfolioFeeCollapsed (inverted)
    this.$scope.$watch(
      () => this.isPortfolioFeeCollapsed,
      (newVal) => {
        this.showPortfolioFee = !newVal;
      }
    );

    // Sync showClientFee with isClientFeeCollapsed (inverted)
    this.$scope.$watch(
      () => this.isClientFeeCollapsed,
      (newVal) => {
        this.showClientFee = !newVal;
      }
    );

    // Sync showFeeTypesFee with isFeeTypesFeeCollapsed (inverted)
    this.$scope.$watch(
      () => this.isFeeTypesFeeCollapsed,
      (newVal) => {
        this.showFeeTypesFee = !newVal;
      }
    );
  }

  exportPortfolioFeesToCSV = ($event: angular.IAngularEvent) => {
    if (this.portfolioFeesRef && this.portfolioFeesRef.exportPortfolioFeesToCSV) {
      this.portfolioFeesRef.exportPortfolioFeesToCSV($event);
    }
  };

  exportClientFeesToCSV = ($event: angular.IAngularEvent) => {
    if (this.clientFeesRef && this.clientFeesRef.exportClientFeesToCSV) {
      this.clientFeesRef.exportClientFeesToCSV($event);
    }
  };

  updateTopFeeTypesFees = (data: Array<any>) => {
    this.topFeeTypesFees = data;
  };

  exportFeeTypesFeesToCSV = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
    if (this.topFeeTypesFees) {
      exportToCSV(this.topFeeTypesFees, "Fee Types", true);
    }
  };
}

export enum FeeCalculationType {
  EDR = 0,
  MCB = 1,
  COMBINED = 2,
}

export const fees: angular.IComponentOptions = {
  template: require("./fees.html"),
  controller: FeesController,
};



// WEBPACK FOOTER //
// ./src/app/fees/fees.ts